import { cn } from "../utils";

export default function HighlightedText({ target, value }) {
    const parts = value.split(new RegExp(`(${target})`, "gi"));

    return (
        <span>
            {parts.map((part, index) => (
                <span
                    key={index}
                    className={cn(
                        "search-bar__text",
                        part.toLowerCase() === target.toLowerCase() &&
                            "search-bar__text--highlight"
                    )}
                >
                    {part}
                </span>
            ))}
        </span>
    );
}
